import { language as lan_uploadFileModal } from "./upload-file-modal";

let language = {
    // 图片上传模态框
    ...lan_uploadFileModal,
    STORE_PRODUCT_SETTING_MOCKUP_MAIN_MOCKUP: "Main Mockup",
    STORE_PRODUCT_SETTING_MOCKUP_LIST_TITLE: "All Product Images",
    STORE_PRODUCT_SETTING_MOCKUP_UPLOAD_RULE: "You may add up to 10 images that will be displayed as alternate product views in your store. Each image must be under 500kb and a maximum of 2,000 x 2,0000 pixels. Supported image types are JPG, HPEG, PNG and GIF.",
    STORE_PRODUCT_SETTING_MOCKUP_IMAGE_ERROR_TIP: "Your product mockup thumbnail loaded failed, you can click to reload the image again.",
    STORE_PRODUCT_SETTING_MOCKUP_IMAGE_FORMAT: "Image Format",
    STORE_PRODUCT_SETTING_MOCKUP_IMAGE_FORMAT_JPG: "JPG",
    STORE_PRODUCT_SETTING_MOCKUP_IMAGE_FORMAT_JPG_DES: "(Smaller file size - your store will load faster.)",
    STORE_PRODUCT_SETTING_MOCKUP_IMAGE_FORMAT_PNG: "PNG",
    STORE_PRODUCT_SETTING_MOCKUP_IMAGE_FORMAT_PNG_DES: "(Larger file size - transparent background.)",
    STORE_PRODUCT_SETTING_MOCKUP_MOCKUP_PREVIEW: "Mockup preview",
    STORE_PRODUCT_SETTING_MOCKUP_EMPTY_IMAGE_TIP: "Product mockup cannot be empty, please upload your product picture.",
    STORE_PRODUCT_SETTING_MOCKUP_ATY_VERIFY_TIP: "The maximum number of product pictures is 10. Please choose to update the picture or delete the picture before adding the picture ",
    // 删除产品图片，提示信息
    STORE_PRODUCT_SETTING_MOCKUP_DELETE_IMAGE_TITLE: "Delete picture!",
    STORE_PRODUCT_SETTING_MOCKUP_DELETE_IMAGE_DES: "Are you sure you want to delete this picture?",
    STORE_PRODUCT_SETTING_MOCKUP_DELETE_IMAGE_SUCCESS: "Delete successfully!",
    STORE_PRODUCT_SETTING_MOCKUP_DELETE_IMAGE_OK_BTN: "OK",
    STORE_PRODUCT_SETTING_MOCKUP_DELETE_IMAGE_CANCEL_BTN: "Cancel",
    // 店铺产品图片为空提示
    STORE_PRODUCT_SETTING_MOCKUP_EMPTY_IMAGE_TITLE: "Product mockup is empty",
    // 产品图片数量小于等于1，禁止删除图片提示信息
    STORE_PRODUCT_SETTING_MOCKUP_DELETE_DISABLE_TITLE: "Delete picture!",
    STORE_PRODUCT_SETTING_MOCKUP_DELETE_DISABLE_DES: "Opps, the product picture cannot be empty.",
    // 图片上传图片数量校验提示
    STORE_PRODUCT_SETTING_MOCKUP_CONFIRM_UPLOAD_QTY_TITLE: "Confirm Upload",
    STORE_PRODUCT_SETTING_MOCKUP_CONFIRM_UPLOAD_DES: "You tried to upload {{uploadQty}} pictures, we can only upload {{allowUploadQty}} for you. Please reselect the picture.",
    // 店铺产品图片数量校验提示
    STORE_PRODUCT_SETTING_MOCKUP_ATY_VERIFY_TITLE: "Product mockups quantity",
    STORE_PRODUCT_SETTING_MOCKUP_ATY_VERIFY_DES: "Opps, Your current number of Product mockups is {{mockupsQty}}. The number of store product images allowed to be added ranges from {{minMockupQty}} to {{maxMockupQty}}.",
    // 店铺产品图片生成中提示
    STORE_PRODUCT_SETTING_MOCKUP_MOCKUP_RUNNING_TITLE: "Running mockup image",
    STORE_PRODUCT_SETTING_MOCKUP_MOCKUP_RUNNING_DES: "Opps, product renderings have not yet been completed, please click [{{buttonText}}] and try again later.",
    STORE_PRODUCT_SETTING_MOCKUP_NAME_RULE_TIP: "name length {{rangeLength}}",
    // mockup图片生成失败
    STORE_PRODUCT_SETTING_MOCKUP_FAILED_TIP: "Mockup Image Generation Failed, Please click to retry.",
    // mockup图片生成中
    STORE_PRODUCT_SETTING_MOCKUP_RUNNING_TIP: "Mockup image is being generated. Please wait and click to retry.",
};


export { language }